import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import styles from './GetStartedTodayMP.module.css';

const GetStartedTodayMP = () => {
    return (
        <Container
            fluid
            className={styles.contentContainer}
        >
            <Container>
                <Row>
                    <Col className='text-center'>
                        <h1 className={styles.getStartedHeader}>Get Started Today with Mainline Plus</h1>
                        <div className={styles.getStartedContainer}>
                            <p>
                                Selling and managing extended service agreements has never been easier. Start using our
                                easy-to-use portal to add labor coverage on all your HVAC equipment installations.
                            </p>
                            <p>
                                We offer a variety of competitive labor reimbursement options to meet your business
                                needs.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default GetStartedTodayMP;
